import apiBase from './base';

export const authenticate = data =>
  apiBase.post('/oauth/token', {
    body: {
      ...data,
      grant_type: 'password',
    },
  });

export const getUser = () => apiBase.get(`/me`);

export const updateUser = (userId, user) =>
  apiBase.put(`/users/provider_update/${userId}`, {
    body: {
      data: { user },
    },
  });

export const forgotPassword = data =>
  apiBase.post(`/forgot_password`, {
    body: {
      data,
    },
  });

export const resetPassword = data =>
  apiBase.post(`/reset_password`, {
    body: {
      data,
    },
  });
